// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"cb6a0c58","455":"bd84859a","977":"38cd73f8"}[chunkId] + ".chunk.js";
};